import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { HSActivationPrintRequest } from "./HSActivationPrintRequest";
import { QREmailRequest } from "./QREmailRequest";
import { PreviewQRRequest } from "./PreviewQRRequest";
import { HSActivationInsertRequest } from "./HSActivationInsertRequest";
import { HSActivationUpdateRequest } from "./HSActivationUpdateRequest";

@Injectable()
export class DataService_HallSweepActivation {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	HSActivationSelectList() {
		var postResult$ = new Subject();
		var url = "HallSweep/HSActivationSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HSActivationInsert(parms: HSActivationInsertRequest) {
		var postResult$ = new Subject();
		var url = "HallSweep/HSActivationInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HSActivationUpdate(parms: HSActivationUpdateRequest) {
		var postResult$ = new Subject();
		var url = "HallSweep/HSActivationUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HSActivationPreviewDebugQRCode(parms: PreviewQRRequest) {
		var postResult$ = new Subject();
		var url = "HallSweep/HSActivationPreviewDebugQRCode";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HSActivationPrint(parms: HSActivationPrintRequest) {
		var postResult$ = new Subject();
		var url = "HallSweep/HSActivationPrint";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HSActivationEmail(parms: QREmailRequest) {
		var postResult$ = new Subject();
		var url = "HallSweep/HSActivationEmail";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
